<div>
  <div class="app-container">
    <section id="main">
      @if (isHomepage) {
        <div id="splash-index">
          <div class="overlay"></div>
          <nav-component></nav-component>
          <router-outlet></router-outlet>
        </div>
      } @else {
        <div [ngStyle]="{ 'min-height': '100vh' }">
          <nav-component></nav-component>
          <router-outlet></router-outlet>
        </div>
      }
    </section>
    <footer>
      <div class="footer-content">
        @if (systemConfigService.config.support.phone) {
          <div>
            Phone: {{ systemConfigService.config.support.phone }}
          </div>
        }
        @if (systemConfigService.config.support.email) {
          <div>
            Email: <a href="mailto:{{ systemConfigService.config.support.email }}">{{ systemConfigService.config.support.email }}</a>
          </div>
        }
        <div>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </div>
      </div>
      <div class="social-footer">
        <ul class="list-inline">
          @if (systemConfigService.config.socials.twitter) {
            <li class="list-inline-item"><a href="https://twitter.com/{{ systemConfigService.config.socials.twitter }}" target="_blank" rel="noreferrer" title="Twitter" alt="Twitter"><i class="fab fa-twitter"></i></a></li>
          }
          @if (systemConfigService.config.socials.facebook) {
            <li class="list-inline-item"><a href="https://www.facebook.com/{{ systemConfigService.config.socials.facebook }}" target="_blank" rel="noreferrer" title="Facebook" alt="Facebook"><i class="fab fa-facebook"></i></a></li>
          }
          @if (systemConfigService.config.socials.instagram) {
            <li class="list-inline-item"><a href="https://www.instagram.com/{{ systemConfigService.config.socials.instagram }}" target="_blank" rel="noreferrer" title="Google plus" alt="Instagram"><i class="fab fa-instagram"></i></a></li>
          }
        </ul>
      </div>
      <div class="footer-legal">Content &copy; {{ systemConfigService.config.name }} {{ year }}</div>
    </footer>
  </div>
</div>

